export default __webpack_public_path__ + "static/media/icon_policy_overview_step3-3.61373944.svg";